export const yearConfigPL4173 = 2024